import { createI18n } from 'vue-i18n';

import en from './en.json';
import ru from './ru.json';

const CIS_REGIONS = new Set(['RU', 'BY', 'KZ', 'UZ', 'KG', 'TJ', 'TM', 'AZ', 'AM', 'GE', 'UA', 'MD']);

function detectLocale(): 'en' | 'ru' {
	const saved = localStorage.getItem('lang');
	if (saved === 'ru' || saved === 'en') return saved;

	for (const lang of navigator.languages ?? [navigator.language]) {
		if (/^ru\b/i.test(lang)) return 'ru';
		try {
			const region = new Intl.Locale(lang).region;
			if (region && CIS_REGIONS.has(region)) return 'ru';
		} catch {
			// ignore
		}
	}
	return 'en';
}

export const i18n = createI18n({
	legacy: false,
	locale: detectLocale(),
	fallbackLocale: 'en',
	messages: { en, ru }
});
